import { Typography, Tooltip, Box } from '@mui/material'

import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'

interface CorrectChoicesViewerProps {
  card: CardActivityWithId
  maxWidth?: number
}

function CorrectChoicesViewer({ card, maxWidth = 150 }: CorrectChoicesViewerProps): JSX.Element {
  const { choices = [], answer = [] } = card

  const correctValues = choices.filter(opt => answer.includes(opt.option)).map(opt => opt.value)

  const displayText = correctValues.join(', ')

  return (
    <Box maxWidth={maxWidth}>
      <Tooltip arrow placement="top" title={displayText}>
        <Typography noWrap color="#475467" lineHeight="20px">
          {displayText}
        </Typography>
      </Tooltip>
    </Box>
  )
}

export default CorrectChoicesViewer
